import versionApi from '@/api/version/versionApi';

export default {
  namespaced: true,
  state: {
    version: {ui: ''}
  },
  getters: {
    uiVersion: state => state.version.ui
  },
  mutations: {
    setVersion(state, data) {
      state.version = data;
    }
  },
  actions: {
    async fetch({commit}) {
      try {
        const response = await versionApi.fetch();
        commit('setVersion', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
}
